<div
  class="lum-c-order-posted"
  [ngClass]="{
    'is-in-modal': isInModal,
    'lum-page lum-page--full-height': !isInModal,
  }"
>
  <div
    class="overlay"
    lumAppLoader
    [loading]="loading"
    [classes]="'loading blur'"
  ></div>

  <ng-container *ngIf="isInModal; else headerWhenIsPage">
    <header class="modal-header align-items-center">
      <h2 class="modal-title">
        <ng-container *ngIf="!loading; else titleWhenLoading">
          Sales Order {{ salesOrder.orderNumber }} ({{ salesOrder.orderId }})
        </ng-container>
      </h2>
      <div class="ml-auto d-flex align-items-center gap-x-2">
        <ng-container *ngTemplateOutlet="actions"></ng-container>
      </div>
      <button class="close ml-0" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </header>
  </ng-container>
  <ng-template #headerWhenIsPage>
    <header class="lum-page-header lum-page-header--sticky lum-page-header--card">
      <h2 class="lum-page-header__heading">
        <a [routerLink]="['/shipping/grid-posted-orders']">Sales Orders</a> /
        <ng-container *ngIf="!loading; else titleWhenLoading">
          {{ salesOrder.orderNumber }} ({{ salesOrder.orderId }})
        </ng-container>
      </h2>
      <div class="lum-page-header__actions">
        <ng-container *ngTemplateOutlet="actions"></ng-container>
      </div>
    </header>
  </ng-template>

  <div class="lum-page-content  lum-c-order-posted__content">
    <section class="lum-page__card">
      <div class="row">
        <div class="col-md-3 mb-4">
          <div class="lum-label">Order ID</div>
          <div class="text-medium">{{ salesOrder.orderId }}</div>
        </div>
        <div class="col-md-3 mb-4">
          <div class="lum-label">Invoice IDs</div>
          <div class="text-medium">
            <ng-container *ngIf="salesOrder?.clientInvoices?.length > 0">
              <a
                *ngFor="
                  let invoice of salesOrder.clientInvoices;
                  trackBy: trackById
                "
                class="lum-chip lum-chip--small  mr-2"
                [href]="'/sales/view/invoices?invoiceId=' + invoice?.id"
                target="_blank"
              >
                {{ invoice?.id }}
              </a>
            </ng-container>
          </div>
        </div>
        <div class="col-md-3 mb-4">
          <div class="lum-label">Status</div>
          <div class="text-medium">
            {{ salesOrder?.orderStatus?.toUpperCase() }}
            <div *ngIf="salesOrder.shipDate">
              <b class="text-green-700">{{
                salesOrder.shipDate | date: 'mediumDate'
              }}</b>
            </div>
            <div *ngIf="salesOrder.shipstationOrderId">
              SSID: {{ salesOrder.shipstationOrderId }}
            </div>
            <div *ngIf="salesOrder.shipOrderError">
              <small class="text-danger">
                {{ salesOrder.shipOrderError }}
              </small>
            </div>
          </div>
        </div>
        <div class="col-md-3 mb-4">
          <div class="lum-label">Date</div>
          <div class="text-medium">
            {{ salesOrder.orderDate | date: 'mediumDate' }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 mb-4">
          <div class="lum-label">Order Number</div>
          <div class="text-medium">
            {{ salesOrder.orderNumber }}
            <div
              *ngIf="showShippingLabelIndicator"
              class="salesorder-shipping-label--wrapper"
            >
              <span
                class="
                  lum-chip lum-chip--label lum-chip--small
                  mt-1 font-normal border-transparent
                  text-green-900 bg-green-300
                  hover:green-400 active:green-500 focus:green-400
                "
              >
                <i class="fas fa-truck"></i>
                <span class="ml-2">Shipping Label Printed</span>
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-3 mb-4">
          <div class="lum-label">Order Type</div>
          <div class="text-medium">
            {{ salesOrder?.purchaseOrder?.supplierOrderType }}
          </div>
        </div>
        <div class="col-md-3 mb-4">
          <div class="lum-label">Order Status</div>
          <div class="text-medium font-semi-bold">
            <div>
              <span
                class="yes text-green-700"
                *ngIf="salesOrder.isPosted == eSalesOrderPostStatus.POSTED"
                >ALLOCATED</span
              >
              <span
                class="no text-yellow-700"
                *ngIf="salesOrder.isPosted == eSalesOrderPostStatus.NOT_POSTED"
                >UNALLOCATED</span
              >
            </div>
            <div
              class="sales-inv-status"
              *ngIf="salesOrder.isPosted == eSalesOrderPostStatus.POSTED"
            >
              <div
                [ngClass]="{
                  'text-green-700': !salesOrder.skipInventory,
                  'text-yellow-700': salesOrder.skipInventory,
                }"
              >
                <i
                  class="fas fa-check-double"
                  *ngIf="!salesOrder.skipInventory"
                ></i>
                <i class="fas fa-times" *ngIf="salesOrder.skipInventory"></i>
                Inventory
              </div>
              <div
                [ngClass]="{
                  'text-green-700': !salesOrder.skipSalesReport,
                  'text-yellow-700': salesOrder.skipSalesReport,
                }"
              >
                <i
                  class="fas fa-check-double"
                  *ngIf="!salesOrder.skipSalesReport"
                ></i>
                <i class="fas fa-times" *ngIf="salesOrder.skipSalesReport"></i>
                Sales Report
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 mb-4" *ngIf="settings.pickAndPackEnabled">
          <div class="lum-label">Pick/Pack Status</div>
          <div class="text-medium font-semi-bold">
            <span
              *ngIf="!salesOrder?.picklist; else picklistLink"
              class="
                {{
                picklistStatusConstant[salesOrder?.pickingStatus] ===
                picklistStatusConstant.NO_ENOUGH_STOCKS
                ? 'text-red-700'
                : ''
                }}
              "
              (click)="$event.stopPropagation()"
            >
              {{ picklistStatusConstant[salesOrder?.pickingStatus] }}
            </span>
            <ng-template #picklistLink>
              <a
                class="
                  {{
                  picklistStatusConstant[salesOrder?.pickingStatus] ===
                  picklistStatusConstant.NO_ENOUGH_STOCKS
                  ? 'text-red-800'
                  : ''
                  }}
                "
                [routerLink]="['/shipping/picklists/', salesOrder?.picklist?.id]"
              >
                {{ picklistStatusConstant[salesOrder?.pickingStatus] }}

                <div class="picklist-link--wrapper">
                  <span
                    class="
                      lum-chip lum-chip--label lum-chip--small
                      mt-1 font-normal
                    "
                    >Picklist #: <b>{{ salesOrder?.picklist?.id }}</b></span
                  >
                </div>
              </a>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 mb-4">
          <div class="lum-label">Customer PO Number</div>
          <div class="text-medium">{{ salesOrder.customerPoNumber }}</div>
        </div>
        <div class="col-md-3 mb-4">
          <div class="lum-label">Order Key</div>
          <div class="text-medium">{{ salesOrder.orderKey }}</div>
        </div>
        <div class="col-md-3 mb-4">
          <div class="lum-label">Source</div>
          <div class="text-medium">{{ salesOrder.source }}</div>
        </div>
        <div class="col-md-3 mb-4">
          <div class="lum-label">Channel</div>
          <div class="text-medium">{{ salesOrder?.channel?.label }}</div>
        </div>
      </div>

      <mat-tab-group>
        <mat-tab label="Ship To">
          <div class="row mb-4">
            <div class="col-md-3">
              <div class="lum-label">Shipping Name</div>
              <div class="text-medium">{{ invoiceClientShippingName }}</div>
            </div>
            <div class="col-md-3">
              <div class="lum-label">Shipping Company</div>
              <div class="text-medium">{{ invoiceClientShippingCompany }}</div>
            </div>
            <div class="col-md-3">
              <div class="lum-label">Shipping Address</div>
              <div class="text-medium">{{ invoiceClientShippingAddress }}</div>
            </div>
            <div class="col-md-3">
              <div class="lum-label">Shipment Tracking #s</div>
              <div class="text-medium">
                {{ salesOrderShipmentTrackingNumbers }}
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Bill To">
          <div class="row mb-4">
            <div class="col-md-3">
              <div class="lum-label">Bill To Name</div>
              <div class="text-medium">{{ salesOrder?.billTo?.name }}</div>
            </div>
            <div class="col-md-3">
              <div class="lum-label">Bill To Company</div>
              <div class="text-medium">{{ salesOrder?.billTo?.company }}</div>
            </div>
            <div class="col-md-3">
              <div class="lum-label">Bill To Address</div>
              <div class="text-medium">{{
                salesOrder?.billTo
                  | addressTransformation: addressTransformationType.ADDRESS
              }}</div>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-md-3">
              <div class="lum-label">Phone</div>
              <div class="text-medium">{{ salesOrder?.billTo?.phone }}</div>
            </div>
            <div class="col-md-3">
              <div class="lum-label">Email</div>
              <div class="text-medium">{{ salesOrder?.billTo?.email }}</div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>

      <mat-divider class="mb-4"></mat-divider>
      <div class="row">
        <div class="col-md-3 mb-4">
          <div class="lum-label">Pick/Pack Updated by</div>
          <div class="text-medium">{{ pickPackUpdateBy }}</div>
        </div>
        <div class="col-md-3 mb-4">
          <div class="lum-label">Invoice Payment Status</div>
          <div class="text-medium">
            <div *ngIf="salesOrder.clientInvoice">
              <span
                *ngIf="
                  salesOrder?.clientInvoice?.paymentStatus ===
                  eInvoicePaymentStatus.UNPAID
                "
                class="kt-badge kt-badge--danger kt-badge--inline kt-badge--pill"
                >Unpaid</span
              >
              <span
                *ngIf="
                  salesOrder?.clientInvoice?.paymentStatus ===
                  eInvoicePaymentStatus.FULLY_PAID
                "
                class="kt-badge kt-badge--success kt-badge--inline kt-badge--pill"
                >Fully Paid</span
              >
              <span
                *ngIf="
                  salesOrder?.clientInvoice?.paymentStatus ===
                  eInvoicePaymentStatus.PARTIALLY_PAID
                "
                class="kt-badge kt-badge--warning kt-badge--inline kt-badge--pill"
                >Partially Paid</span
              >
              <span
                *ngIf="
                  salesOrder?.clientInvoice?.paymentStatus ===
                  eInvoicePaymentStatus.PENDING_PAYMENT
                "
                class="kt-badge kt-badge--info kt-badge--inline kt-badge--pill"
                >Pending Payment</span
              >
              <div class="text-nowrap pointer payment-logs-tooltip mt-1">
                {{ salesOrder.clientInvoice?.paidAmount | currency: '' }} /
                {{ salesOrder.clientInvoice?.netTotalAmount | currency: '' }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 mb-4">
          <div class="lum-label">Verified By</div>
          <div class="text-medium">{{ picklistVerifiedBy }}</div>
        </div>
        <div class="col-md-3 mb-4">
          <div class="lum-label">Verified Date by</div>
          <div class="text-medium">
            {{ salesOrder?.picklistOrder?.verifiedAt | date: 'mediumDate' }}
          </div>
        </div>
      </div>
      <div class="row  mb-4">
        <div class="col-md-3">
          <div class="lum-label">Ship By Date</div>
          <div class="text-medium">
            {{ salesOrder?.shipByDate | date: 'mediumDate' }}
          </div>
        </div>
        <div class="col-md-3">
          <div class="lum-label">Earliest Ship Date</div>
          <div class="text-medium">
            {{ salesOrder?.doNotShipBefore | date: 'mediumDate' }}
          </div>
        </div>
        <div
          *ngIf="
            'utah-UTAH-338-expose_requested_shipping_service_field' | featureFlag
          "
          class="col-md-3"
        >
          <div class="lum-label">Requested Shipping Service</div>
          <div class="text-medium">
            {{ salesOrder?.requestedShippingService }}
          </div>
        </div>
        <div class="col-md-3">
          <div class="lum-label">Tags</div>
          <div class="text-small">
            <ng-container *ngFor="let tag of salesOrder?.tags; trackBy: trackById">
              <span
                class="
                  lum-chip lum-chip--label lum-chip--small
                  mr-2 mb-1 font-normal
                "
                >{{ tag.name }}</span
              >
            </ng-container>
          </div>
        </div>
      </div>
    </section>

    <section *ngIf="hasCustomFieldValues" class="lum-page__card">
      <lum-custom-field-display-columns
        [customFieldValues]="customFieldValues"
      ></lum-custom-field-display-columns>
    </section>

    <section class="lum-page__card">
      <mat-tab-group
        [selectedIndex]="currentActiveTab"
        (selectedIndexChange)="currentActiveTab = $event"
      >
        <mat-tab label="Items">
          <lum-order-ordered-items-table
            [orderItems]="salesOrder.orderItems"
          ></lum-order-ordered-items-table>
          <div class="mt-4">
            <div class="d-flex justify-content-end">
              <div
                class="
                  d-flex w-50 justify-content-between p-2 ml-2
                  border rounded bg-light
                "
              >
                <div class="fw-bold"> Total Tax</div>
                <div
                  ><b>{{ salesOrder.taxAmount | currency }}</b></div
                >
              </div>

              <div
                class="
                  d-flex w-50 justify-content-between p-2 ml-2
                  border rounded bg-light text-danger
                "
              >
                <div class="fw-bold"> Total Discount</div>
                <div
                  ><b>{{ salesOrder.totalDiscount | currency }}</b></div
                >
              </div>

              <div
                class="
                  d-flex w-50 justify-content-between p-2 ml-2
                  border rounded bg-light
                "
              >
                <div class="fw-bold">Order Total</div>
                <div
                  ><b>{{ salesOrder.orderTotal | currency }}</b></div
                >
              </div>
            </div>
          </div>
          <div class="mt-3" *ngIf="salesOrder.isPosted">
            <div class="text-medium">Picking Items</div>
            <lum-order-posted-items-table
              [pickingItems]="pickingItems"
              (createAdjustmentEntryEvent)="createAdjustmentEntryEvent.emit($event)"
            ></lum-order-posted-items-table>
          </div>
          <div class="mt-3">
            <div class="d-flex justify-content-end">
              <div
                class="
                  d-flex w-50 justify-content-between p-2
                  border rounded bg-light
                "
              >
                <div class="fw-bold">Total</div>
                <div
                  ><b>{{ salesOrder.orderTotal | currency }}</b></div
                >
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab *ngIf="'red_DV-2840_partial_fulfillment' | featureFlag">
          <ng-template mat-tab-label>
            <label
              matTooltip="Shipments created in Luminous, including partial shipments, split orders, etc."
              class="m-0 cursor-pointer"
            >
              Fulfillment Orders
            </label>
          </ng-template>
          <div class="lum-page-header__actions">
            <lum-fulfillment-orders-grid-actions
              [salesOrderId]="salesOrder?.id"
              [selectedRowCount]="selectedRowCount$ | async"
              [selectedRowIds]="selectedRowIds$ | async"
              [selectedRows]="selectedRows$ | async"
              [selectedfulfillmentConfirmationValues]="
                selectedfulfillmentConfirmationValues$ | async
              "
              (clearGridState)="clearGridTrigger.emit()"
              (refetchGridData)="refetchGridDataTrigger.emit()"
              (createInvoicesEvent)="
                onCreateInvoiceFromFulfillmentOrderEvent($event)
              "
            >
            </lum-fulfillment-orders-grid-actions>
          </div>
          <lum-fulfillment-orders-ag-table
            *ngIf="!loading"
            height="500px"
            [salesOrderId]="salesOrder?.id"
            [clearGridTrigger]="clearGridTrigger"
            [refetchGridDataTrigger]="refetchGridDataTrigger"
            (selectedRowCountEvent)="onSelectedRowCountEvent($event)"
            (selectedRowIdsEvent)="onSelectedRowIdsEvent($event)"
            (selectedfulfillmentConfirmationValuesEvent)="
              onSelectedfulfillmentConfirmationValuesEvent($event)
            "
            (selectedRowsEvent)="onSelectedRowsEvent($event)"
          >
          </lum-fulfillment-orders-ag-table>

          <!-- <lum-order-remote-oms-orders-table
              [salesOrderShipments]="salesOrder.salesOrderShipments"
              (printShippingLabelEvent)="
                onTriggerActions('print_shipping_labels', $event)
              "
            ></lum-order-remote-oms-orders-table> -->
        </mat-tab>
        <mat-tab label="Refund/Return Orders">
          <lum-refund-return-orders-ag-table
            *ngIf="!loading"
            [parentSalesOrderId]="salesOrder?.id"
          ></lum-refund-return-orders-ag-table>
        </mat-tab>
        <mat-tab label="Invoices">
          <lum-sales-order-ag-invoices
            [salesOrder]="salesOrder"
          ></lum-sales-order-ag-invoices>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <label
              matTooltip="Shipments recorded directly from OMS."
              class="m-0 cursor-pointer"
            >
              Shipments
            </label>
          </ng-template>
          <div class="row">
            <div class="col-md-12">
              <lum-shipments-ag-table
                *ngIf="!loading"
                height="500px"
                [salesOrderId]="salesOrder?.id"
                [showGridActions]="true"
              >
              </lum-shipments-ag-table>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </section>

    <section class="lum-page__card">
      <div class="row">
        <div class="col-md-12">
          <div class="text-medium">Activity Logs</div>
          <lum-activity-log
            *ngIf="!loading"
            [subjectId]="salesOrder.id"
            [subjectType]="'sales_order'"
          ></lum-activity-log>
        </div>
      </div>
    </section>
  </div>
</div>

<ng-template #titleWhenLoading>...</ng-template>
<ng-template #actions>
  <button
    type="button"
    class="lum-button lum-button--secondary"
    [disabled]="!(salesOrder | canEditSalesOrder)"
    [matTooltip]="
      !(salesOrder | canEditSalesOrder)
        ? 'Sales order status is \'' + salesOrder?.orderStatus + '\'.'
        : null
    "
    (click)="onTriggerActions(ESalesOrderAction.EDIT_SALES_ORDER)"
    >Edit</button
  >
  <button
    type="button"
    class="lum-button lum-button--primary"
    [matMenuTriggerFor]="menu"
  >
    Actions
    <i class="flaticon-more"></i>
  </button>

  <mat-menu class="lum-mat-menu" #menu="matMenu">
    <button
      mat-menu-item
      type="button"
      (click)="onTriggerActions(ESalesOrderAction.UPDATE_ORDER_STATUS)"
    >
      Update Order Status
    </button>
    <button
      *ngIf="settings.canShipOrders && salesOrder.channelId == 0"
      mat-menu-item
      type="button"
      (click)="onTriggerActions(ESalesOrderAction.PUSH_TO_OMS)"
    >
      Push To Integration (Shipstation)
    </button>
    <button
      *ngIf="showCreatePicklist"
      mat-menu-item
      type="button"
      (click)="onTriggerActions(ESalesOrderAction.CREATE_PICKLIST)"
    >
      Create Picklist
    </button>
    <a
      *ngIf="showVisualPicking"
      mat-menu-item
      [routerLink]="['/shipping/visual-picking/', salesOrder?.picklist?.id]"
    >
      Visual Picking
    </a>
    <a
      *ngIf="showPacking"
      mat-menu-item
      [routerLink]="['/shipping/packing/', salesOrder?.picklist?.id]"
    >
      Packing Page
    </a>
    <button
      mat-menu-item
      type="button"
      (click)="onTriggerActions(ESalesOrderAction.PREVIEW_PICKLIST)"
    >
      Preview Picklist Items
    </button>
    <button
      mat-menu-item
      type="button"
      (click)="onTriggerActions(ESalesOrderAction.UPDATE_TAGS)"
    >
      Update Tags
    </button>
    <button
      mat-menu-item
      type="button"
      (click)="onTriggerActions(ESalesOrderAction.UPDATE_CUSTOM_FIEDS)"
    >
      Update Custom Fields
    </button>
    <button
      mat-menu-item
      type="button"
      (click)="onTriggerActions(ESalesOrderAction.PRINT_SHIPPING_LABELS)"
    >
      Print Shipping Labels
    </button>
    <button
      mat-menu-item
      type="button"
      (click)="onTriggerActions(ESalesOrderAction.ADD_TRACKING_NUMBER)"
    >
      Add Tracking Numbers
    </button>
    <button
      mat-menu-item
      type="button"
      [disabled]="
        ('red_DV-3362_fo_shipment_splits' | featureFlag) &&
        salesOrder?.fulfillmentOrders?.length === 0
      "
      (click)="onTriggerActions(ESalesOrderAction.AUTO_GENERATE_FULFILLMENT_ORDERS)"
    >
      Auto Generate Fulfillment Orders
    </button>
    <button
      mat-menu-item
      type="button"
      (click)="onTriggerActions(ESalesOrderAction.PUSH_FULFILLMENT)"
    >
      Push Tracking to Sales Channel
    </button>
    <button
      mat-menu-item
      type="button"
      (click)="onTriggerActions(ESalesOrderAction.EXPORT_PACKING_SLIP)"
    >
      Export Packing Slips
    </button>
    <button
      mat-menu-item
      type="button"
      (click)="onTriggerActions(ESalesOrderAction.EXPORT_SALES_ORDER)"
    >
      Export Sales Order
    </button>
    <button
      *ngIf="salesOrder.isPosted"
      mat-menu-item
      type="button"
      (click)="onTriggerActions(ESalesOrderAction.UNPOST_ORDER)"
    >
      Unallocate Order
    </button>
    <button
      mat-menu-item
      type="button"
      class="text-red-500"
      (click)="onTriggerActions(ESalesOrderAction.DELETE_SALES_ORDER)"
    >
      <i class="fas-fa-trash"></i> Delete Sales Order
    </button>
  </mat-menu>
</ng-template>
